<template>
  <div>
    <PageTitle
      title="Edit Guests"
      :backBtn="true"
      :permission="'Guest Edit'"
      :showLoading="isLoading"
    />
    <ValidationObserver ref="observer">
      <v-container fluid class="lighten-12">
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="4">
        
                  
                    <v-card >
                        <v-container fluid>
              
        
                <v-col cols="12" lg="12" class="pb-0">
                  <v-flex >
                    <FileUpload
                      ref="fileUpload"
                      title="Image"
                  style=""
                      :multiple="false"
                      :externalFiles="
                      Guest.image ? [Guest.image] : []
                    "
                      class=" background-size:100% 100%;"
                      v-model="selectedImages"
                      size="10000"
                        @isImageUpdated="onChangeImageUpload"
                      :types="['jpeg', 'png', 'jpg']"
                      :showPreview="true"
                      :camera="true"
                     
                    />
                  </v-flex>
                </v-col>
          </v-container>
            </v-card>
                
          
      
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="8">
            <v-card class="lighten-12">
              <v-card-title>General </v-card-title>
              <v-container fluid>
                <v-row>
                  <template v-if="messages">
                    <v-alert
                      v-for="msg in messages"
                      :key="msg"
                      class="messages"
                      dense
                      outlined
                      type="error"
                      >{{ msg }}</v-alert
                    >
                  </template>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="12" md="4" lg="4">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name=" Name"
                      vid="name"
                      rules="required|no_spaces_only"
                    >
                      <v-text-field
                        hide-details="auto"
                        dense
                        outlined
                        v-model="Guest.name"
                        :error-messages="errors"
                        label="Name"
                        required
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <ValidationProvider v-slot="{ errors }">
                      <v-text-field
                        v-model="Guest.passport_number"
                        :error-messages="errors"
                        outlined
                        required
                        dense
                        hide-details="auto"
                        label="Passport Number"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="Nic number "
                      rules="required"
                    >
                      <v-text-field
                        v-model="Guest.nic_number"
                        :error-messages="errors"
                        outlined
                        required
                        dense
                        hide-details="auto"
                        label="Nic Number"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>

            <v-row>
              <v-col cols="12">
                <v-card class="lighten-12">
                  <v-card-title>Contacts</v-card-title>
                  <v-container fluid class="light gray lighten-12">
                    <ValidationObserver ref="address">
                      <v-row>
                        <v-col cols="4">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Address"
                            rules="required"
                          >
                            <v-text-field
                              hide-details="auto"
                              outlined
                              dense
                              v-model="Guest.address"
                              :error-messages="errors"
                              label="Address"
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Phone"
                            :rules="{
                              required: true,
                              regex: /^(0\d{9}|\+94\d{9})$/,
                            }"
                          >
                            <v-text-field
                              hide-details="auto"
                              outlined
                              dense
                              maxlength="13"
                              v-model="Guest.phone"
                              :error-messages="errors"
                              label="Phone"
                              required
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Email"
                            rules="email"
                          >
                            <v-text-field
                              hide-details="auto"
                              outlined
                              dense
                              v-model="Guest.email"
                              :error-messages="errors"
                              label="Email Address"
                              required
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="4">
                          <v-text-field
                            hide-details="auto"
                            outlined
                            dense
                            v-model="Guest.company"
                            :error-messages="errors"
                            label="Company"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4">
                          <datePickComponent
                            labelname="Date Of Birth"
                            v-model="Guest.date_of_birth"
                          />
                        </v-col>
                      </v-row>

                      <!-- <v-divider /> -->
                    </ValidationObserver>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

     
    
     

        <v-row> </v-row>

        <!-- Submit -->

        <v-row>
          <v-col cols="12" sm="12" md="6" lg="12" class="content-flex-end">
            <v-btn depressed small class="text-white btn_medium" @click="clear"
              >Clear</v-btn
            >
            <v-btn
              depressed
              small
              class="text-white btn_blue btn_medium w-100"
              @click="submit"
              :disabled="isDisabledSubmit"
              >Submit</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </ValidationObserver>
  </div>
</template>

<script>
import { required, email, max, regex } from "vee-validate/dist/rules";
import datePickComponent from "../../../components/base/DateComponent";
import FileUpload from "@/components/base/FileUpload";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";



import { Guest } from "../../../models/Guest";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} is required",
});

extend("no_spaces_only", {
  validate: (value) => {
    return value && value.trim().length > 0;
  },
  message: "{_field_} cannot be empty or spaces only",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});

extend("regex", {
  ...regex,
  message: "The value is not a valid phone number",
});

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    datePickComponent,
    FileUpload
  },
  data: () => ({
    
    checkbox: null,
    Guest: new Guest(),
    isLoading: false,
    errors: [],
    messages: [],
    selectedImages:"",
     imageUpdated: null,
    isDisabledSubmit: false,
    countries: { id: "", name: "" },
  }),

  methods: {
    async submit() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.UpdateGuest();
      } else if (isValid) {
      }
    },
    clear() {
      this.Guest = new Guest();
      this.$refs.observer.reset();
    },
     GetGuestDetails() {
      let GuestId = this.$route.params.id;
      this.$store
        .dispatch("guest/GetGuest", GuestId)
        .then((res) => {
        
          this.Guest = new Guest().Initialise(res.data);
        })
        .catch((err) => {
          this.messages = err.data.title;
        });
    },
    UpdateGuest() {
      
      this.isLoading = true;
      this.isDisabledSubmit = true;

      this.$store
        .dispatch("guest/EditGuest", this.Guest.toRequest(this.Guest))
        .then(async(res) => {
          
          this.succeeed = true;
           await this.UploadGuestImage(this.Guest.id)
          this.isDisabledSubmit = false;
          this.$router.push("/guests");
          this.$toast.success("Guest edited successfully");
          this.isLoading = false;
        })
        .catch((err) => {
          this.$refs.observer.setErrors(err.data.error);
          this.messages = err.data.title;
          this.isLoading = false;
          this.isDisabledSubmit = false;
          this.$toast.error("Guest edit failed");
          // this.isDisabledSubmit = false;
        });
    },

    GetCountries() {
      this.$store
        .dispatch("GetCountries")
        .then((res) => {
          this.countries = res.data.data;
        })
        .catch((err) => {
          this.messages = err.data.title;
          this.isLoading = false;
        });
    },


    onChangeImageUpload(value) {
      this.imageUpdated = value;
    },
   
      async UploadGuestImage(guestid) {

      let fromData = new FormData();

      if (this.selectedImages && this.imageUpdated) {

        fromData.append("image", this.selectedImages);
        fromData.append("id", guestid);
        return await this.$store
          .dispatch(`guest/UploadGuestImage`, fromData)
          .then(() => {})
          .catch(() => {
            this.$toast.error("Guest image uploading failed");
          });
      } else if (this.imageUpdated == false) {

        fromData.append("image", null);
        fromData.append("id", guestid);
        return await this.$store
          .dispatch(`guest/UploadGuestImage`, fromData)
          .then(() => {})
          .catch(() => {
            this.$toast.error("Guest image uploading failed");
          });

          
      } else {
        return true;
      }
      

      formData.append("id", id);
      console.log(this.selectedImages);
    },

  },
  created() {
      this.GetGuestDetails();
    this.GetCountries();
  },
};
</script>
